//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uid } from "quasar";
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";

export default {
    name: "CreateEntityModal",
    components: {
        AQDropdown,
        AQInput,
        AQButton,
        AQTooltip,
        AQCheckbox,
        AQCard
    },
    props: {
        entityData: { type: null },
        entityName: {
            type: String,
            default: ""
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        entityList: {
            type: Array,
            default: () => []
        },
        isSave: {
            type: Boolean,
            default: false
        },
        dbConnectionsOptions: {
            type: Array,
            default: () => []
        },
        sourceType: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            canPullStructure: false,
            invalidInput: {},
            checkNameForDuplicates: {},
            tableDefaultValue: "",
            schemaDefaultValue: "",
            resetSource: false,
            resetSchema: false,
            resetTable: false,
            tableKey: "empty",
            tableData: [],
            wrongPattern: false,
            duplicatedName: false,
            schemaOptions: [],
            tableOptions: [],
            structureRead: "read",
            structureActions: ["read"],
            clickValue: "two",
            lista2: ["one"],
            entity: {
                name: "",
                connectionCode: "",
                schema: "",
                tableName: []
            },
            showModal: true,
            headerActions: [
                {
                    label: this.$t("globalDataModel.deleteEntity")
                }
            ],
            localEntityName: null,
            localTableData: {}
        };
    },
    computed: {
        ...mapGetters("main", ["getInfoApp"]),
        setEntityName() {
            let name = "";
            if (this.isEdit) {
                name = this.localEntityName;
            } else {
                name = this.entityName || this.entity.name;
            }
            return name;
        },
        errorLabel() {
            let errorMsg;
            if (!this.$v.entity.name.required) {
                errorMsg = this.$t("globalDataModel.emptyName");
            } else if (this.wrongPattern) {
                errorMsg = this.$t("globalDataModel.wrongPatternErr");
            } else if (this.duplicatedName) {
                errorMsg = this.$t("globalDataModel.duplicatedName");
            }
            return errorMsg;
        },
        isError() {
            return this.$v.entity.name.$error || this.wrongPattern || this.duplicatedName;
        }
    },
    watch: {
        entityName: {
            handler(val) {
                if (val) {
                    this.entity.name = val;
                }
            },
            immediate: true
        },
        tableData: {
            handler(val) {
                if (val && val.length && this.entity.name) {
                    this.$emit("canSave", true);
                } else {
                    this.$emit("canSave", false);
                }
            },
            immediate: true
        },
        isSave: {
            handler(val) {
                if (val) {
                    const payload = {
                        attributes: this.tableData
                            .filter(elem => elem.validType)
                            .map(elem => ({
                                code: elem.code,
                                externalType: elem.columnType,
                                entityCode: this.entityData.code || null,
                                externalName: elem.externalName,
                                name: this.setNameToSend(elem),
                                status: elem.status || null,
                                type: elem.gdmType
                            })),
                        entityCode: this.entityData.code,
                        entityDbType: this.entity.connectionCode[0].dbType,
                        connectionCode: this.entity.connectionCode[0].value,
                        externalSchema: this.entity.schema[0].value,
                        externalName: this.entity.tableName[0].value,
                        name: this.setEntityName
                    };
                    this.$emit("saveNewEntity", { entity: payload, isEdit: this.isEdit });
                }
            }
        }
    },
    validations: {
        entity: {
            name: {
                required
            }
        }
    },
    created() {
        this.getDDLData();
        if (this.isEdit) {
            this.getSavedExternaStructure(this.entityData.code).then(data => {
                this.setStructureData(data.data.attributes);
            });
        }
    },
    methods: {
        setNameToSend(elem) {
            let name = elem.columnName;
            if (this.isEdit && !elem.changed && elem.status && elem.status !== "NEW") {
                name = null;
            }
            return name;
        },
        inputBackground(row) {
            const inputBgClass = [];
            if (this.isEdit) {
                if (row.status === "NEW") {
                    inputBgClass.push("added-input");
                } else if (row.status === "REMOVED") {
                    inputBgClass.push("removed-input");
                }
            }
            return inputBgClass;
        },
        setClass(row) {
            const cssClass = [];
            const isNew = row.status === "NEW";
            const isRemoved = row.status === "REMOVED";
            if (!row.validType && !(isNew || isRemoved)) {
                cssClass.push("invalid-type");
            }
            if (this.checkNameForDuplicates[row.id] || this.invalidInput[row.id]) {
                cssClass.push("error-height");
            }
            if (isNew) {
                cssClass.push("new-row");
            } else if (isRemoved) {
                cssClass.push("removed-row");
            }
            return cssClass;
        },
        setStructureData(data) {
            this.tableData = data.map(item => {
                const newItem = { ...item };
                newItem.id = uid();
                return newItem;
            });
            this.localTableData = JSON.parse(JSON.stringify(this.tableData));
        },
        checkNameForDuplicatesAtt(id) {
            let result = false;
            if (Object.keys(this.checkNameForDuplicates).length) {
                result = this.checkNameForDuplicates[id];
            }
            if (Object.keys(this.invalidInput).length && !result) {
                result = this.invalidInput[id];
            }
            const canSave = !!(!result && typeof result === "boolean" && this.entity.name && !this.duplicatedName);
            this.$emit("canSave", canSave);
            return result;
        },
        checkAttName(value, id, index) {
            const checkAttNames = [];
            this.tableData.forEach(elem => {
                if (elem.columnName === value) {
                    checkAttNames.push(elem);
                }
                if (this.isEdit) {
                    if (elem.id === this.localTableData[index].id && elem.columnName !== this.localTableData[index].columnName) {
                        elem.changed = true;
                    }
                }
            });
            if (checkAttNames.length && checkAttNames.length > 1) {
                this.checkNameForDuplicates[id] = true;
            } else if (checkAttNames.length && checkAttNames.length === 1 && this.checkNameForDuplicates[id]) {
                delete this.checkNameForDuplicates[id];
            }
            if (value.includes(".")) {
                this.invalidInput[id] = true;
            } else if (this.invalidInput[id] && !value.includes(".")) {
                delete this.invalidInput[id];
            }
        },
        getDDLData(srcType) {
            this.schemaDefaultValue = "";
            this.tableDefaultValue = "";
            this.getSchemas(srcType || this.sourceType).then(schemas => {
                this.schemaOptions = schemas.data.map(item => ({
                    label: item,
                    value: item
                }));
                const schemaTable = this.isEdit ? this.entityData.externalSchema : schemas.data[0];
                this.getTables({ code: srcType || this.sourceType, schema: schemaTable }).then(tables => {
                    this.tableOptions = tables.data.map(item => ({
                        label: item.name,
                        value: item.name
                    }));
                    this.schemaDefaultValue = this.isEdit ? this.entityData.externalSchema : this.schemaOptions[0].value;
                    if (this.isEdit) {
                        this.tableDefaultValue = this.entityData.externalName;
                    } else {
                        this.tableDefaultValue = this.tableOptions.length ? this.tableOptions[0].value : "";
                    }
                    this.canPullStructure = !!(this.tableOptions.length && this.schemaOptions.length);
                    this.resetSchema = false;
                    this.resetTable = false;
                });
            });
        },
        ...mapActions("GDM", ["getIntegrations", "getSchemas", "getTables", "pullStructure", "getSavedExternaStructure", "getRefreshStructure"]),
        onSource(evt) {
            if (evt && evt.length && evt[0].value === "aurachain") {
                this.$emit("isAurachain", true);
            } else if (evt && evt.length) {
                this.tableData = [];
                this.resetSchema = true;
                this.resetTable = true;
                this.getDDLData(evt[0].value);
            }
        },
        onSchema(evt) {
            if (evt && evt.length) {
                this.tableData = [];
                this.tableOptions = [];
                this.tableDefaultValue = "nullvalue";
                this.resetTable = true;
                this.getTables({ code: this.sourceType, schema: evt[0].value }).then(tables => {
                    this.tableOptions = tables.data.map(item => ({
                        label: item.name,
                        value: item.name
                    }));
                    this.tableDefaultValue = this.tableOptions.length ? this.tableOptions[0].value : "nullvalue";
                    this.resetTable = false;
                    this.tableKey = evt[0].value;
                    this.canPullStructure = !!this.tableOptions.length;
                });
            }
        },
        onTable(evt) {
            if (evt && evt.length) {
                this.tableData = [];
            }
        },

        checkEntityName() {
            if (this.entity.name) {
                if (this.entityData && this.entityData.name === this.entity.name) {
                    this.localEntityName = null;
                } else {
                    this.localEntityName = this.entity.name;
                }
                // eslint-disable-next-line
                const validatePattern = new RegExp("^[a-zA-Z][ a-zA-Z0-9\_-]*$");
                this.wrongPattern = !validatePattern.test(this.entity.name);
                const checkNameForDuplicates = this.entityList.find(elem => elem.name.trim().toLowerCase() === this.entity.name.trim().toLowerCase());
                this.duplicatedName = !!checkNameForDuplicates;
                if (!this.wrongPattern && !checkNameForDuplicates && this.tableData.length) {
                    this.$emit("canSave", true);
                } else {
                    this.$emit("canSave", false);
                }
            } else {
                this.wrongPattern = false;
                this.duplicatedName = false;
                this.disableSave = true;
                this.$emit("canSave", false);
            }
        },
        getStructure() {
            if (this.isEdit) {
                this.getRefreshStructure(this.entityData.code).then(data => {
                    this.setStructureData(data.data);
                    this.$emit("canSave", true);
                });
            } else {
                const payload = {
                    code: this.entity.connectionCode[0].value,
                    schema: this.entity.schema[0].value,
                    table: this.entity.tableName[0].value
                };
                this.pullStructure(payload).then(data => {
                    this.setStructureData(data.data);
                    this.$emit("canSave", true);
                });
            }
        }
    }
};
